import { Component, HostListener, inject, Inject, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Mtrwd } from '../entity/Mtrwd-angular';
import { MaterialModule } from 'jk-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { QuillHtmlComponent } from 'jk-service';
import { JkBaseOption } from 'jk-service';
import { jkRestReturn } from 'jk-service';
import { JkDialogEditComponent } from 'jk-service';
import { MtrwdService, templateUrlConfigMtr } from '../_service_mtr';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';



@Component({
  selector: 'app-mtrwd-edit-mobile',
  templateUrl: './mtrwd-edit-mobile.component.html',
  styles: [], // ### 讓dialog可以resize dialogResizeCss
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,
    MaterialModule,
    FormsModule,
    QuillModule],
  providers: [],// ### jackie add
})
export class MtrwdEditMobileComponent extends JkDialogEditComponent<MtrwdService, Mtrwd> {

  constructor(injector: Injector,
    public override dialogRef: MatDialogRef<MtrwdEditMobileComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    //super(injector);
    super(injector, dialogRef, data);
  }
}
